<template>
  <div class='proces'>
    <mvp :open='open' :type='"process"' :edit='edit'></mvp>
    <div class="items" v-show = 'open'>
      <item v-for="(item,index) in data" :key="index" :data='item' :type='"process"' :edit='edit' :level='1' :list='data' :view='view'></item>
    </div>
  </div>
</template>

<script>
import mvp from './components/mvp'
import item from './components/item'

export default {
  name: 'process',
  components: {
    mvp,
    item
  },
  props: {
    edit: {
      type: Boolean
    },
    data: {
      type: Array
    },
    open: {
      type: Boolean
    },
    view: {
      type: Array
    }
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.proces{
  .items{
    float: left;
  }
}
</style>
